module.exports = __webpack_public_path__ + "static/media/calendarOrange.173fb389.svg";